import { useRouter } from 'next/router';
import { useState, useEffect } from 'react';
import { useAuthStore } from '@/stores/auth'; 

interface UseAuthenticatedHookOptions {
  replaceRoute?: boolean,
  authorizedRedirect?: string,
  unauthorizedRedirect?: string
}

export function useAuthenticated (options: UseAuthenticatedHookOptions) {
  const router = useRouter();
  const [ authState ] = useAuthStore();
  const [ isLoggedIn, setIsLoggedIn ] = useState(true);
  const [ state, setState ] = useState(authState);

  const checkLoggedIn = () => {
    return authState.ready && !!authState.auth;
  };

  const navigate = (route) => {
    if (options.replaceRoute) router.replace(route);
    else router.push(route);
  };
  
  useEffect(() => {
    setState(authState);

    if (!authState.ready) return;

    setIsLoggedIn(checkLoggedIn());
    
    if (checkLoggedIn()) {
      if (options.authorizedRedirect) navigate(options.authorizedRedirect);
    } else {
      if (options.unauthorizedRedirect) navigate(options.unauthorizedRedirect);
    }
  }, [ authState ]);

  return {
    state,
    isLoggedIn
  };
}
